import {
    ETL,
} from './ETL.js';

// global data
export let wayfindingFD = {};

export let mapData = {};
export let systemUUID = '';
export let activeAccountM1Key = '';
export let Connections = {};

export let locationMarkerUse = false;

export const wayfindingStartup = (fd, system_uuid) => {
	wayfindingFD = ETL(fd || {});

	systemUUID = system_uuid || '';

	mapData = {
		showInstructions: false,
		showInstructionsIndex: 0
	};

	activeAccountM1Key = Object.keys(wayfindingFD).find((key) => {
		return key.startsWith('account.');
	});

	locationMarkerUse = getSystemOrPropertyOrAccountSetting('wf_location_marker_use', `system.${systemUUID}`, true) || false;

	let systemData = wayfindingFD[`system.${systemUUID}`];
	let wayfindingProject = false;

	for (let [key, value] of Object.entries(systemData)) {
		if (key.startsWith('wf_point.')) {
			wayfindingProject = true;
		}
	}

	if (wayfindingProject) {
		Connections = generateConnections(wayfindingFD);
	}

	return wayfindingProject;
};

export const getActiveMap = () => {
	const activeSystem = `system.${systemUUID}`;

	let activeMap = '';
	let activeSystemPoint = '';
	let activeMapPointGroup = '';

	Object.entries(wayfindingFD).forEach(([m1Key, m1Data,]) => {
		if (m1Key.startsWith(activeSystem)) {
			Object.keys(m1Data).forEach((m2Key) => {
				if (m2Key.startsWith('wf_point.')) {
					activeSystemPoint = m2Key;
				}
			});
		}
	});
	
	Object.entries(wayfindingFD).forEach(([m1Key, m1Data,]) => {
		if (m1Key.startsWith('wf_point_group.')) {
			Object.keys(m1Data).forEach((m2Key) => {
				if (m2Key === activeSystemPoint) {
					activeMapPointGroup = m1Key;
				}
			});
		}
	});

	Object.entries(wayfindingFD).forEach(([m1Key, m1Data,]) => {
		if (m1Key.startsWith('wf_map_graphic.')) {
			Object.keys(m1Data).forEach((m2Key) => {
				if (m2Key === activeMapPointGroup) {
					activeMap = m1Key;
				}
			});
		}
	});

	return activeMap;
};

export const getSystemOrPropertyOrAccountSetting = (mapSetting, systemName = null, checkbox = false) => {
	const activeMap = getActiveMap();
	let settingValue = '';

	const account = wayfindingFD[activeAccountM1Key] || {};
	const activeSystemGroup = wayfindingFD?.[getParentKeyNameFromTarget('system_group', activeMap)] || {};
	const activeSystem = wayfindingFD?.[systemName] || {};

	let accountSetting;
	if (mapSetting in account) {
		accountSetting = {
			value: account[mapSetting] ?? null
		};
	}

	let propertySetting;
	if (mapSetting in activeSystemGroup) {
		propertySetting = {
			value: activeSystemGroup[mapSetting] ?? null,
		};
	}

	let systemSetting;
	if (mapSetting in activeSystem) {
		systemSetting = {
			value: activeSystem[mapSetting] ?? null,
		};
	}	

	if ((systemSetting?.value && !checkbox) || (checkbox && systemSetting?.value && systemSetting?.value !== false)) {
		settingValue = systemSetting.value;
	} else if ((propertySetting?.value && !checkbox) || (checkbox && propertySetting?.value && propertySetting?.value !== false)) {
		settingValue = propertySetting.value;
	} else if ((accountSetting?.value && !checkbox) || (checkbox && accountSetting?.value && accountSetting?.value !== false)) {
		settingValue = accountSetting.value;
	} else if (checkbox) {
		settingValue = false;
	} else {
		settingValue = '';
	}

	return settingValue;
};

export const getParentKeyNameFromTarget = (targetName, matchingValue) => {
	let parentName = '';
	for (let m1KeyName of Object.keys(wayfindingFD)) {
		if (m1KeyName.startsWith(targetName)) {
			for (let m2KeyName of Object.keys(wayfindingFD[m1KeyName])) {
				if (m2KeyName === matchingValue) {
					parentName = m1KeyName;
					break;
				}
			}

			if (parentName) {
				break;
			}
		}
	}

	return parentName
};

export const dijkstra = (pendingUpdates, currentMap, start, end, adaCompliant) => {
	// Initialize the distances and visited nodes
	const distances = {};
	const visited = {};
	const lineData = Object.keys(pendingUpdates[currentMap]).find(key => key.startsWith('wf_line_group.'));
	const pointData = Object.keys(pendingUpdates[currentMap]).find(key => key.startsWith('wf_point_group.'));
	let nonAdaCompliantPoints = [];

	// create copies to avoid mutation
	let pointDataCopy = { ...pendingUpdates[pointData] };
	let lineDataCopy = { ...pendingUpdates[lineData] };
	if (pointDataCopy.point_restrictions) {
		delete pointDataCopy.point_restrictions;
	}


	for (const point in pendingUpdates[pointData]) {
		let hasADA = false;

		if (pendingUpdates[point]?.point_restriction && typeof pendingUpdates[point].point_restriction === 'string') {
			const pointRestrictionArr = JSON.parse(pendingUpdates[point].point_restriction);
			if (pointRestrictionArr.includes('ADA') && adaCompliant) {
				hasADA = true;
				delete pointDataCopy[point];
				nonAdaCompliantPoints.push(point);
			}
		}

		if (!hasADA || !adaCompliant) {
			distances[point] = Infinity;
			visited[point] = false;
		}
	}
	distances[start] = 0;
  
	Object.keys(lineDataCopy).forEach((line) => {
		nonAdaCompliantPoints.forEach((nonAdaPt) => {
			// remove the line if it contains a non-ADA compliant point
			if (lineDataCopy[line]?.[nonAdaPt]) {
				delete lineDataCopy[line];
			}
		});
	});

	// Iterate through the nodes until the end point is found
	let currentNode = getClosestNode(distances, visited);

	while (currentNode !== null && currentNode !== end) {
		// Update the distances for the current node's neighbors
		let neighboringLines = [];
		let neighbors = [];
		for (const line in lineDataCopy) {
			Object.keys(pendingUpdates[lineData][line]).forEach((pt) => {
				if (pt === currentNode) {
					neighboringLines.push(line);
				}
			});
		}

		neighboringLines.forEach((line) => {
			Object.keys(pendingUpdates[lineData][line]).forEach((pt) => {
				if (pt !== currentNode) {
					neighbors.push(pt);
				}
			});
		});

		neighbors.forEach((neighbor) => {
			nonAdaCompliantPoints.forEach((nonAdaPt) => {
				if (neighbor === nonAdaPt) {
					console.log('Dijkstra - Non-ADA point found', nonAdaPt);
				}
			});

			if (pendingUpdates[pointData]?.[neighbor] === undefined) {
				debugger;
			}
			if (pendingUpdates[pointData]?.[currentNode] === undefined) {
				debugger;
			}
			const distanceToNeighbor = calculateDistanceBetweenPoints(pendingUpdates[pointData][currentNode], pendingUpdates[pointData][neighbor]);
			const totalDistance = distances[currentNode] + distanceToNeighbor;
			if (totalDistance < distances[neighbor]) {
				distances[neighbor] = totalDistance;
			}
		});
  
		// Mark the current node as visited and get the next closest node
		visited[currentNode] = true;
		currentNode = getClosestNode(distances, visited);
	}
  
	// Check if end node is reachable
	if (distances[end] === Infinity || currentNode === null) {
		console.log("Dijkstra - No viable path found between start and end points");
		return [];
	}
  
	// Build and return the shortest path
	const shortestPath = [];
	let pathNode = end;
	let shortestPathCounter = 0;
	while (pathNode !== undefined && pathNode !== start) {
		shortestPathCounter++;
		if (shortestPathCounter > 500) {
			console.error("Dijkstra - Bailing due to dijkstra infinite loop! In the wayfinding tool, check that the location point is connected to the path network, and not orphaned!");
			break;
		}

		shortestPath.unshift(pathNode);
		let neighboringLines = [];
		let neighbors = [];
		for (const line in lineDataCopy) {
			Object.keys(pendingUpdates[lineData][line]).forEach((pt) => {
				if (pt === pathNode) {
					neighboringLines.push(line);
				}
			})
		}
		neighboringLines.forEach((line) => {
			Object.keys(pendingUpdates[lineData][line]).forEach((pt) => {
				if (pt !== pathNode) {
					neighbors.push(pt);
				}
			})
		})

		// No neighbors means no path
		if (neighbors.length === 0) {
			console.log("Dijkstra - No neighbors found during path reconstruction - path is broken");
			return [];
		}

		const bestNeighbor = neighbors.reduce((best, neighbor) => {
			if (distances[neighbor] < distances[best]) {
				return neighbor;
			}
			return best;
		}, neighbors[0]);
		
		// If best neighbor has infinite distance, no viable path exists
		if (distances[bestNeighbor] === Infinity) {
			console.log("Dijkstra - No viable path exists - best neighbor has infinite distance");
			return [];
		}
		
		pathNode = bestNeighbor;
	}
	shortestPath.unshift(start);
	console.log('shortest path');
	console.log(shortestPath);
	return shortestPath;
};

export const findChildGroups = (parentGroup, groupType) => {
    if (!parentGroup || !groupType) {
        return;
    }
    let childGroupArr = [];
    
    for(let vtGroup of Object.keys(parentGroup)) {
        if (vtGroup.startsWith(groupType)) {
            childGroupArr.push(vtGroup);
        }
    }
    
    return childGroupArr;
};

export const findPointInData = (pointsObj, targetPt) => {
    let pointFound = false;
    for (let keyName of Object.keys(pointsObj)) {
        if (keyName === targetPt) {
            pointFound = true;
        }
    }
    return pointFound;
};

export const findBuildingGroundFloorAp = (mapWithChildGroupsAndPoints, endingVtMapArr, newEndLocationMap) => {
	let mapGroup = [];
	let buildingGroundFloorMap = null;
	let additionalSplitVtGroups = [];
	let groundFloorApGroupArr = [];
	let groundFloorApPointsArr = [];
	let groundFloorApGroups = [];
	let apPointsArr = [];

	const createApPointsArr = (map, vtGroup) => {
		let hasVtGroup = false;

		if (!mapWithChildGroupsAndPoints[map]) {
			console.error(`Wayfinding: Can't find the target's building ground floor! In the wayfinding tool, check that Vertical Transport groups are setup correctly to the floor map.`);
			return;
		}

		for(let mapGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
			if (mapGroup.startsWith('wf_map_ap_group') && !groundFloorApGroups.includes(mapGroup)) {
				groundFloorApGroups.push(mapGroup);
				apPointsArr.push(mapWithChildGroupsAndPoints[map][mapGroup]);
			}

			if (vtGroup === mapGroup && !mapGroup.includes(map)) {
				hasVtGroup = true;
			}
		}

		let match = (vtGroup && hasVtGroup) || !vtGroup;
		findGroundFloorAp(groundFloorApGroups, map, match);
	};

	const findGroundFloorAp = (groundFloorApGroups, map, match) => {
		if (groundFloorApGroups.length > 0 && match) {
			buildingGroundFloorMap = map;
			groundFloorApGroupArr = [...groundFloorApGroups];
			groundFloorApPointsArr = [...apPointsArr];
		}
	};

	// find the ground floor, store the ap groups, and ap points
	if (!endingVtMapArr || (Array.isArray(endingVtMapArr) && endingVtMapArr.length === 0)) {
		createApPointsArr(newEndLocationMap); // no vt groups due to a single ground floor setup
	} else {
		// store maps that share the same vt groups with the end map
		for (let map of Object.keys(mapWithChildGroupsAndPoints)) {
			for(let vtGroup of endingVtMapArr) {
				for(let mapVtGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
					if (vtGroup === mapVtGroup && !mapGroup.includes(map)) {
						mapGroup.push(map);
					}
				}
			}
		}

		// find additional vt groups that don't stop on all floors (required for traversing floors when using multiple vt groups for three phases)
		for (let map of mapGroup) {
			for(let mapVtGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
				if (!additionalSplitVtGroups.includes(mapVtGroup) && mapVtGroup.startsWith('wf_map_vt_group')) {
					additionalSplitVtGroups.push(mapVtGroup);
				}
			}
		}

		for (let map of Object.keys(mapWithChildGroupsAndPoints)) {	
			groundFloorApGroups = [];
			apPointsArr = [];

			for(let vtGroup of additionalSplitVtGroups) {
				createApPointsArr(map, vtGroup);
			}
		}
	}

	return {buildingGroundFloorMap, groundFloorApGroupArr, groundFloorApPointsArr};
};

export const findPrimaryPath = (locationAndMapArr, targetPoint, endLocationMap) => {
    let primaryTargetPoint = null;
    let primaryLocationMap = null;
    

    if (Array.isArray(locationAndMapArr) && locationAndMapArr.length >= 1) {
        locationAndMapArr.forEach((locationObj) => {
            if (locationObj.isPrimaryMap) {
                primaryTargetPoint = locationObj.pointName;
                primaryLocationMap = locationObj.map;
            }
        });
    }

    return {primaryTargetPoint, primaryLocationMap};
};

export const findLocationToAnotherBuilding = (mapWithChildGroupsAndPoints, campusMap, pointIsOnCampusMap, newEndLocationMap, targetLocation, locationInSameBuildingAsSystem, apChildGroupArr, endingVtMapArr, apTransitionMap) => {
	let finalEndLocationPoint = targetLocation;
	let finalEndLocationMap = newEndLocationMap;
	const { buildingGroundFloorMap, groundFloorApGroupArr, groundFloorApPointsArr } = findBuildingGroundFloorAp(mapWithChildGroupsAndPoints, endingVtMapArr, newEndLocationMap);

	if (!locationInSameBuildingAsSystem && !pointIsOnCampusMap && campusMap && ((mapWithChildGroupsAndPoints[campusMap] && apChildGroupArr) || (!locationInSameBuildingAsSystem && apTransitionMap))) {

		// from groundFloorApGroupArr, find the matching AP group on the campus map, and find the point that is not contained in the groundFloorApPointsArr
		if (buildingGroundFloorMap && groundFloorApGroupArr.length > 0) {
			groundFloorApGroupArr.forEach((group) => {
				for (let campusGroup of Object.keys(mapWithChildGroupsAndPoints[campusMap])) {
					if (group === campusGroup) {
						if (!groundFloorApPointsArr.includes(mapWithChildGroupsAndPoints[campusMap][campusGroup])) {
							finalEndLocationMap = campusMap;

							// current requirements is that one point is returned, but future code may need all ap points to determine the shortest path
							finalEndLocationPoint = mapWithChildGroupsAndPoints[campusMap][campusGroup];
						}
					}
				}
			})
		}
	}

	return { finalEndLocationMap, finalEndLocationPoint, buildingGroundFloorMap };
};

const getClosestNode = (distances, visited) => {
	let closestNode = null;
	let shortestDistance = Infinity;
	for (const point in distances) {
		if (!visited[point] && distances[point] < shortestDistance) {
			closestNode = point;
			shortestDistance = distances[point];
		}
	}
	return closestNode;
};

export const generateConnections = (pendingUpdates) => {
	const connections = {};
	let connectionCounter = 0;
	
	// Find all map graphics with vt groups
	const mapGraphics = Object.entries(pendingUpdates).filter(([key, value]) => 
		key.startsWith('wf_map_graphic.') && value.map_vt_group
	);
	
	// Process each building VT group (parent)
	mapGraphics.forEach(([mapKey, mapValue]) => {
		const buildingVtGroup = pendingUpdates[mapValue.map_vt_group];
		
		// Process each child VT group
		Object.entries(buildingVtGroup)
			.filter(([key]) => key.startsWith('wf_map_vt_group.') && key !== mapValue.map_vt_group)
			.forEach(([childVtGroupKey, _]) => {
				const childVtGroup = pendingUpdates[childVtGroupKey];
				const points = Object.keys(childVtGroup)
					.filter(key => key.startsWith('wf_point.'));
				
				if (points.length >= 2) {
					// Generate all possible point pairs
					const pointPairs = generatePairs(points);
					
					// Process each pair of points
					pointPairs.forEach(([point1, point2]) => {
						// Find which maps these points belong to
						const map1Info = findMapForPoint(pendingUpdates, point1, mapGraphics);
						const map2Info = findMapForPoint(pendingUpdates, point2, mapGraphics);
						
						if (map1Info && map2Info) {
							const [map1, point1Id] = map1Info;
							const [map2, point2Id] = map2Info;
							
							// Only create connection if points belong to different maps
							if (map1 !== map2 && !connectionExists(connections, map1, map2, childVtGroupKey)) {
								const connectionId = `connection_${connectionCounter}`;
								connections[connectionId] = {
									[map1]: point1Id,
									[map2]: point2Id,
									"group_name": childVtGroup.display_name || `Connection ${connectionCounter}`,
									"vt_group_name": childVtGroupKey,
									"instructions": childVtGroup.instruction_text || "Take the elevator to"
								};
								connectionCounter++;
							}
						}
					});
				}
			});
	});
	
	return connections;
};

export const calculateDistanceBetweenPoints = (point1, point2) => {
	const dx = point1[0] - point2[0];
	const dy = point1[1] - point2[1];
	return Math.sqrt(dx * dx + dy * dy);
};

export const getTime = () => {
	let value = typeof performance === 'function' ? performance.now() : Date.now();
	return value;
};

export const getVectorFromTwoPoints = (point1, point2) => {
	return {
		x: point2[0] - point1[0],
		y: point2[1] - point1[1],
	};
};

export const getDistance = (touches) => {
	const [touch1, touch2] = touches;
	const dx = touch2.clientX - touch1.clientX;
	const dy = touch2.clientY - touch1.clientY;
	return Math.sqrt(dx * dx + dy * dy);
};

// Helper function to generate all possible pairs from an array
const generatePairs = (arr) => {
	const pairs = [];
	for (let i = 0; i < arr.length - 1; i++) {
		for (let j = i + 1; j < arr.length; j++) {
			pairs.push([arr[i], arr[j]]);
		}
	}
	return pairs;
};

// Helper function to check if a similar connection already exists
const connectionExists = (connections, map1, map2, vtGroupName) => {
	return Object.values(connections).some(connection => {
		const connectionMaps = Object.keys(connection).filter((key) => {
			return key.startsWith('wf_map_graphic.')
		});

		return (
			// Check if it's the same pair of maps
			connectionMaps.includes(map1) && 
			connectionMaps.includes(map2) &&
			// Check if it's from the same vt group set
			connection.vt_group_name === vtGroupName
		);
	});
};

// Helper function to find which map a point belongs to
const findMapForPoint = (pendingUpdates, pointId, mapGraphics) => {
	for (const [graphicKey, graphicValue] of mapGraphics) {
		const pointGroup = pendingUpdates[graphicValue.map_points];
		if (pointGroup && pointId in pointGroup) {
			return [graphicKey, pointId];
		}
	}
	return null;
};

export const calculatePathDistance = (pendingUpdates, pathArr) => {
	if (!pathArr) {
		console.error(`Wayfinding: Can't calculate path, no path could be generated.`);
		return;
	}

	let totalDistance = 0;

	for (let i = 1; i < pathArr.length; i++) {
		const startPoint = pendingUpdates[pathArr[i - 1]];
		const endPoint = pendingUpdates[pathArr[i]];

		// Check if both start and end points are available in pendingUpdates
		if (startPoint && endPoint) {
			const deltaX = endPoint.x - startPoint.x;
			const deltaY = endPoint.y - startPoint.y;

			const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
			totalDistance += distance;
		} else {
			console.error(`Wayfinding: Coordinates not found for points ${pathArr[i - 1]}, ${pathArr[i]}`);
		}
	}

	return totalDistance;
};

export const mapHasMatchingChildGroupPoint = (pendingUpdates, endLocationMap, groupKey) => {
	if (!endLocationMap || !groupKey) {
		console.error('Wayfinding: end map or group not found! In the wayfinding tool, check that Vertical Transport groups are setup correctly to the floor map.');
		return false;
	}

	const apGroupData = pendingUpdates[groupKey];
	let mapPointsName = pendingUpdates[endLocationMap].map_points;
	let mapPointsGroup = pendingUpdates[mapPointsName];
	let match = false;

	Object.keys(apGroupData).forEach((childPointName) => {
		Object.keys(mapPointsGroup).forEach((mapPoint) => {
			if (childPointName === mapPoint) {
				match = true;
			}
		});
	});

	return match;
};

export const encodeUUIDToBase64 = (uuidString) => {
	// Convert hexadecimal string to binary data
	let binaryData = '';
	for (var i = 0; i < uuidString.length; i += 2) {
		binaryData += String.fromCharCode(parseInt(uuidString.substr(i, 2), 16));
	}
	
	// Use btoa() function to encode the binary data to Base64
	return btoa(binaryData);
};

export const debugActive = () => {
	const location = window.location;
	const searchParams = new URLSearchParams(location.search);
	const debugParam = searchParams.get('debug');
	return debugParam === '1' ? true : false;
};

export const qaActive = () => {
	const location = window.location;
	const searchParams = new URLSearchParams(location.search);
	const debugParam = searchParams.get('qa');
	return debugParam === '1' ? 1 : 0;
};

export const findComponentsWithSettings = (data, settingNames) => {
    const matchingSettings = {};
    
    Object.keys(data).forEach(key => {
        if (key.startsWith("setting.") && 
            data[key]?.name && 
            settingNames.includes(data[key].name)) {
            
            matchingSettings[data[key].name] = key;
        }
    });
    
    let mobileComponent = null;
    
    Object.keys(data).forEach(key => {
        if (key.startsWith("component.") && 
            data[key]?.display_name === "Mobile") {
            mobileComponent = data[key];
        }
    });
    
    if (!mobileComponent) {
        return {};
    }
    
    const result = {};
    
    settingNames.forEach(settingName => {
        const settingKey = matchingSettings[settingName];
        
        if (settingKey) {
            if (mobileComponent[settingKey]) {
                result[settingName] = mobileComponent[settingKey].bool || false;
            } else {
                result[settingName] = false;
            }
        } else {
            result[settingName] = false;
        }
    });
    
    return result;
};